<template>
    <div class="relative w-full">
        <input-text
            :value="value"
            :name="name"
            class="pr-16"
        />

        <div class="absolute inset-y-0 right-0 flex items-center px-3 pt-1 margin-px text-grey-darker">
            <base-dropdown placement="bottom-start">
                <template v-slot:trigger="{ open }">
                    <button
                        v-clipboard:copy="value"
                        v-clipboard:success="open"
                        class="text-blue focus:outline-none"
                    >
                        copy
                    </button>
                </template>

                <template v-slot:menu>
                    <div class="max-w-xs px-2 py-1 text-sm dropdown-menu mt-3px">
                        Copied!
                    </div>
                </template>
            </base-dropdown>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                validator: String,
                default: null
            },
            name: {
                type: String,
                required: true
            }
        }
    }
</script>
